import React, { useEffect, useState } from "react";
import styles from "./GalleryPage.module.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { REACT_APP_API_URL } from "../../env";

const fallbackImages = {
  newsletter: "/images/Newsletter_thumbnail.jpg",
  advertorial: "/images/Advertorial_thumbnail.jpg",
  booklet: "/images/MIning_tourism_thumbnail.jpg",
  article: "/images/Article_thumbnail.png",
  brochure: "/images/unsplash3.jpg",
  campaign: "/images/unsplash4.jpg",
  others: "/images/unsplash2.jpg",
};

const isExplicitlyDisabled = (value) => {
  if (value === undefined || value === null || value === "") return false;
  if (typeof value === "boolean") return value === false;
  const normalized = String(value).trim().toLowerCase();
  return normalized === "0" || normalized === "false" || normalized === "off" || normalized === "no";
};

function GalleryPage() {
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}/api/dashboard/admin/media-categories`
        );
        const data = (response?.data?.data || []).filter(
          (item) => !isExplicitlyDisabled(item.showOnWebsite) && !isExplicitlyDisabled(item.bitStatus)
        );
        const mapped = data.map((item) => {
          const key = String(item.categoryKey || "others").toLowerCase();
          const thumbnailPath = item.thumbnailPath
            ? `${REACT_APP_API_URL}/${String(item.thumbnailPath).replace(/\\/g, "/")}`
            : fallbackImages[key] || fallbackImages.others;

          return {
            key,
            title: item.title || key,
            description:
              item.description ||
              "Explore curated tourism publications and promotional media collections.",
            count: Number(item.mediaFileCount || 0),
            imageUrl: thumbnailPath,
          };
        });
        setSections(mapped);
      } catch (error) {
        console.error("Error fetching media categories:", error);
        setSections([]);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className={styles.gallerySection}>

      <div className={styles.bannerContainer}>
        <img
          src="/images/unsplash7.jpg"
          alt="preview"
          className={styles.bannerImage}
        />
        <h2 className={styles.bannerText}>MEDIA VAULT</h2>
      </div>

      {/* Improved Cards */}
      <div
        className="row g-4 justify-content-center "
        style={{
          margin: "40px 15px 60px",
        }}
      >
        {sections.map((section, index) => (
          <div
            key={section.key}
            className="col-12 col-md-6"
          >
            <div
              className="responsive-gallery-card"
              onClick={() => navigate(`/gallery-section/${section.key}`)}
              data-aos="fade-up"
              data-aos-delay={index * 80}
              style={{
                cursor: "pointer",
                background: "#fff",
                borderRadius: "26px",
                overflow: "hidden",
                border: "1px solid rgba(0,0,0,0.06)",
                boxShadow: "0 15px 40px rgba(0,0,0,0.06)",
                transition: "all 0.35s ease",
                height: "100%",
                display: "flex",
                alignItems: window.innerWidth <= 768 ? "stretch" : "center",
                flexDirection: window.innerWidth <= 768 ? "column" : "row",
                padding: window.innerWidth <= 768 ? "16px" : "18px",
                gap: "18px",
                minHeight: window.innerWidth <= 768 ? "auto" : "320px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow =
                  "0 25px 50px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0px)";
                e.currentTarget.style.boxShadow =
                  "0 15px 40px rgba(0,0,0,0.06)";
              }}
            >
              {/* IMAGE */}
              <div
                className="responsive-gallery-image"
                style={{
                  position: "relative",
                  width: window.innerWidth <= 768 ? "100%" : "240px",
                  minWidth: window.innerWidth <= 768 ? "100%" : "240px",
                  height: window.innerWidth <= 768 ? "240px" : "280px",
                  borderRadius: "22px",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                {/* Ribbon */}
                {/* <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "65px",
                    height: "65px",
                    background: "#ff9800",
                    clipPath: "polygon(0 0, 100% 0, 0 100%)",
                    zIndex: 2,
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "14px",
                      left: "10px",
                      color: "#fff",
                      fontSize: "15px",
                      fontWeight: "700",
                      transform: "rotate(-45deg)",
                    }}
                  >
                    ★ 4.8
                  </span>
                </div> */}

                {/* Heart */}
                {/* <div
                  style={{
                    position: "absolute",
                    top: "14px",
                    right: "14px",
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 3,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                  }}
                >
                  <i
                    className="fas fa-heart"
                    style={{
                      color: "#ff9800",
                      fontSize: "15px",
                    }}
                  ></i>
                </div> */}

                {/* Image */}
                <img
                  src={section.imageUrl}
                  alt={section.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>

              {/* CONTENT */}
              <div
                className="responsive-gallery-content"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  width: "100%",
                  minHeight: "auto",
                }}
              >
                {/* Location */}
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#777",
                    fontSize: "18px",
                    marginBottom: "10px",
                  }}
                >
                  <i className="fal fa-map-marker-alt"></i>
                  Jharkhand Tourism
                </div> */}

                {/* Title */}
                <h3
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    color: "#0c3b2e",
                    marginBottom: "12px",
                    lineHeight: "1.2",
                  }}
                >
                  {section.title}
                </h3>

                {/* Description */}
                <p
                  style={{
                    color: "#666",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    marginBottom: "18px",
                  }}
                >
                  {section.description}
                </p>

                {/* Bottom */}
                <div
                  style={{
                    marginTop: "auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "18px",
                  }}
                >
                  {/* Count */}
                  <div>
                    <div
                      style={{
                        fontSize: "25px",
                        fontWeight: "600",
                        lineHeight: "1",
                        color: "#111",
                      }}
                    >
                      {section.count}
                    </div>

                    <span
                      style={{
                        fontSize: "15px",
                        color: "#777",
                      }}
                    >
                      Media Files
                    </span>
                  </div>

                  {/* Button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/gallery-section/${section.key}`);
                    }}
                    style={{
                      border: "1px solid #111",
                      background: "#fff",
                      borderRadius: "40px",
                      padding: "10px 18px",
                      fontSize: "15px",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    View Files
                    <i className="fal fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}

export default GalleryPage;
